import getItems from './getItems'
import sendReminders from './sendReminders'
import deleteDeclarations from './deleteDeclarations'

export const getItemsPromise = getItems
export const sendRemindersPromise = sendReminders
export const deleteDeclarationsPromise = deleteDeclarations
